import { Button, Divider, Header, Tag, Text } from '@wework/dieter-ui'

import React, { useEffect, useState } from 'react'
import { ElevatorFoyerIcon } from '../Icons'
import Row from '../Common/Row'

import { withManager } from '@wework/react-floormap'
import { withSnackbar } from '../../hoc/SnackBarProvider'

import { useSidebar } from '../../hoc/withSidebar'
import compose from '../../utils/compose'
import { Loader } from 'semantic-ui-react'
import PlanUnit from '../DownloadButton/PlanUnit'

function DownloadPlans({ manager, buildingId, snackBars }) {
  const { closeSideBar } = useSidebar()
  const [data, setData] = useState<any>([])
  const [buildingData, setBuildingData] = useState<
    | {
        url: string
        name: string
      }
    | undefined
  >()

  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    const fetchFloorPlans = async () => {
      const client = manager.getClient()
      try {
        const response = await client.get(`/buildings/${buildingId}/media`, {})
        const { data, meta } = response
        if (!meta.success) {
          throw new Error(meta.message)
        }
        setLoading(false)
        setData(data.attributes.floors)
        setBuildingData({
          url: data.attributes.url,
          name: data.attributes.name,
        })
      } catch (error) {
        setLoading(false)
        snackBars.addAlert({
          text: `There was a problem getting sales floor plans, ${error}`,
          variant: 'error',
        })
      }
    }

    fetchFloorPlans()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buildingId])

  const availablePlans = data?.reduce(
    (a, b) => a + (b.url.length > 0 ? 1 : 0),
    0
  )

  return (
    <>
      <div
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 28,
        }}
      >
        <Header as="h3" style={{ margin: 0 }}>
          Download
        </Header>
        <Button basic onClick={closeSideBar} icon="close" />
      </div>
      <Text style={{ marginBottom: 24 }}>
        Download the original export of sales floor plan form Revit.
      </Text>
      <Divider light />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'scroll',
          marginBottom: 12,
        }}
      >
        {loading ? (
          <div
            style={{
              height: 150,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Loader active style={{ position: 'fixed' }} size="small" />
            <span style={{ marginTop: 12 }}>Loading...</span>
          </div>
        ) : (
          <>
            {data &&
              data.length > 0 &&
              data.map(plan => (
                <PlanUnit
                  plan={plan}
                  buildingData={buildingData}
                  extension="PNG"
                />
              ))}
            <PlanUnit
              plan={{
                name: 'All floors',
                url: buildingData?.url,
              }}
              extension="PDF"
              buildingData={buildingData}
            />
            <Divider light style={{ marginTop: 24, marginBottom: 24 }} />
            <Text size="tiny">
              The same sales floor plan can also be found on Stargate.
            </Text>
          </>
        )}
      </div>
    </>
  )
}

export default compose(withManager())(withSnackbar(DownloadPlans))
